module.exports = __webpack_public_path__ + "img/chivas-form-main-bg.4f7d6342.png";